import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination])

export default function Sliders() {
  const SLIDER_CONTAINERS = {
    'mtt-exhibitions': {
      slidesPerView: 1.05,
      watchOverflow: true,
      spaceBetween: 32,
      centerInsufficientSlides: false,
      breakpoints: {
        580: {
          slidesPerView: 1.4
        },
        800: {
          slidesPerView: 2.2,
        },
        1200: {
          slidesPerView: 2.5,
        },
        1300: {
          spaceBetween: 48,
          slidesPerView: 2.80,
        }
      }
    },
    'mtt-image-slider': {
      slidesPerView: 1.2,
      watchOverflow: true,
      spaceBetween: 20,
      centerInsufficientSlides: false,
      grabCursor: true,
      breakpoints: {
        850: {
          spaceBetween: 40,
          slidesPerView: 1.5
        }
      }
    },
    'mtt-ticket-types': {
      slidesPerView: 1.07,
      watchOverflow: true,
      spaceBetween: 8,
      centerInsufficientSlides: false,
      grabCursor: false,
      breakpoints: {
        400: {
          slidesPerView: 1.2
        },
        600: {
          spaceBetween: 20,
          slidesPerView: 1.4
        },
        750: {
          spaceBetween: 20,
          slidesPerView: 2,
        },
        1250: {
          spaceBetween: 20,
          slidesPerView: 3
        },
        1500: {
          spaceBetween: 20,
          slidesPerView: 4,
        },
        1550: {
          spaceBetween: 40,
          slidesPerView: 4,
        }
      }
    },
  }

  if (SLIDER_CONTAINERS) {
    for (const property in SLIDER_CONTAINERS) {
      if (property) {
        const SLIDER_CONTAINER = document.querySelectorAll('.' + property)

        if (SLIDER_CONTAINER.length) {
          for (let i = 0; i < SLIDER_CONTAINER.length; i++) {

            const SWIPER = new SwiperSlider(SLIDER_CONTAINER[i], SLIDER_CONTAINERS[property])
            SWIPER.init()
          }
        }
      }
    }
  }
}

class SwiperSlider {
  constructor (slider, options) {
    this.slider = slider
    this.swiper = this.slider.querySelector('.swiper')
    this.options = options
    this.arrow_prev = this.slider.querySelector('.mtt-arrow--prev')
    this.arrow_next = this.slider.querySelector('.mtt-arrow--next')
    this.pagination = this.slider.querySelector('.mtt-pagination')

    if (this.arrow_prev && this.arrow_next) {
      this.options['navigation'] = {
        nextEl: this.arrow_next,
        prevEl: this.arrow_prev
      }
    }

    if (this.pagination) {
      this.options['pagination'] = {
        el: this.pagination,
        type: "progressbar",
      }
    }

    this.init = () => {
      this.createSlider()
    }
  }

  createSlider () {
    new Swiper(this.swiper, this.options)
  }

}
